import { createStore } from 'vuex'

export default createStore({
  state: {
    // lang: null,
  },
  getters: {
  },
  mutations: {
    // 切換語系設定
    // setLang (state, value) {
    //   state.lang = value;
    // }
  },
  actions: {
  },
  modules: {
  }
})
